import { useUser } from "@components/user-context";
import { useApiKeys } from "@pages/settings/api-keys";
import { PrimaryButton } from "@shared/buttons";
import Spinner from "@shared/spinner";

import { LinkClipboardButton } from "./link-clipboard-button";
import { Table } from "./table";

export const ApiKeys = () => {
  const { user } = useUser();
  const {
    apiKeys,
    loading: apiKeysLoading,
    createNewApiKey,
    createNewApiKeyLoading,
  } = useApiKeys();

  if (apiKeysLoading) {
    return <Spinner />;
  }

  return (
    <div className="flex flex-col gap-4">
      <Table>
        <thead>
          <tr>
            <th className="border-r">Data-client-ID</th>
            <th>API Key</th>
          </tr>
        </thead>
        <tbody>
          {apiKeys.map((key) => (
            <tr key={key} className="odd:bg-cosmic-5 even:bg-white border-t">
              <td className="border-r">
                <div className="w-full inline-flex justify-between items-center">
                  <code className="text-interstellar">
                    {user.displayUserId}
                  </code>
                  <LinkClipboardButton
                    value={user.displayUserId}
                    name="Data-client-ID"
                  />
                </div>
              </td>
              <td>
                <div className="w-full inline-flex justify-between items-center">
                  <code className="text-interstellar">{key}</code>
                  <LinkClipboardButton value={key} name="API Key" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="inline-flex gap-4 items-center">
        <PrimaryButton
          className="w-fit px-4 py-1.5 space-x-2"
          onClick={() => {
            createNewApiKey();
          }}
          disabled={createNewApiKeyLoading}
        >
          <div className="inline-flex items-center justify-center gap-2 it">
            {!createNewApiKeyLoading ? (
              <>
                <i className="fa-sharp fa-regular fa-refresh" />
                <span>Generate a new API Key</span>
              </>
            ) : (
              <>
                <span>
                  <i className="fas fa-refresh fa-spin text-lg text-cosmic" />
                </span>
                <span className="font-semibold">Generating new key...</span>
              </>
            )}
          </div>
        </PrimaryButton>
      </div>
      <div className="mt-10 inline-flex flex-col gap-2">
        <b>Generating an API Key will yield:</b>
        <ul className=" list-disc pl-4">
          <li className="mb-1">
            <span>
              <code className="px-2 bg-interstellar-3 border rounded">
                Data-client-ID
              </code>{" "}
              used to identify you as the customer
            </span>
          </li>
          <li>
            <span>
              <code className="px-2 bg-interstellar-3 border rounded">
                API Key
              </code>{" "}
              used to Authenticate the API call
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};
